/**
 * Created by don on 9/14/15.
 */
'use strict';

var SoaCollection = require('bunsen/collections/SoaCollection');
var PublicationAttributeValueWrapper = require('bunsen/models/inventory/PublicationAttributeValueWrapper');
var PublicationAttribute = require('bunsen/models/inventory/PublicationAttribute');
var PublicationAttributeWrappers;

/**
 * @class PublicationAttributeWrappers
 * @extends SoaCollection
 */

PublicationAttributeWrappers = module.exports = SoaCollection.extend({

    model: PublicationAttributeValueWrapper,

    /**
     * @returns {PublicationAttributeValueWrapper|undefined}
     */
    getMerchandisePending: function () {
        return this.getAttribute(PublicationAttribute.MERCHANDISE_PENDING_AUTH);
    },

    /**
     * @returns {PublicationAttributeValueWrapper|undefined}
     */
    getMerchandisePublished: function () {
        return this.getAttribute(PublicationAttribute.MERCHANDISE_PUBLISHED_AUTH);
    },

    getCategory : function () {
        return this.getAttribute(PublicationAttribute.CATEGORY);
    },

    /**
     * Returns the attribute wrapper model with the provided attribute name if found, otherwise returns undefined
     * @param name Name of the attribute we're looking for
     * @returns {PublicationAttributeValueWrapper|undefined}
     */
    getAttribute: function (name) {
        return this.find(function (model) {
            return model.get('attribute.name') === name;
        });
    }

});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/inventory/PublicationAttributeWrappers.js
// module id = 2627
// module chunks = 63